export const URL = {
  // dev

  // API_BASE_URL: "http://localhost:5200",
  // API_BASE_URL: "http://192.168.1.7:5200",

  API_BASE_URL: "https://api.rilindia.biz",
  // colne
  // API_BASE_URL: "https://cloneapi.rilindia.online",
  // API_BASE_URL: "https://tiny-tan-puffer-tie.cyclic.cloud",
  API_BASE_URL_2: "https://api.rilindia.biz",

  // apipublic

  getAchiverswinnerPubList: "/publicApi/getAchiverswinnerPubList",
  getnotificationPubList: "/publicApi/getnotificationPubList",
  getOneUserPerCountry: "/publicApi/getOneUserPerCountry",
  getOneUserPerCity: "/publicApi/getOneUserPerCity",
  createcategories: "/apihome/createcategories",
  getCategory: "/publicApi/getCategory",
  userSearchProduct: "/publicApi/userSearchProduct",
  getcartProduct: "/publicApi/getcartProduct",
  referCheck: "/publicApi/referCheck",
  getbrandforpro: "/publicApi/getbrandforpro",
  getMarqusesList: "/publicApi/getMarqusesList",
  getuserOrderDetailsPub: "/publicApi/getuserOrderDetailsPub",
  registerUser: "/publicApi/registerUser",
  otpVerifyuser: "/publicApi/otpVerifyuser",

  // user

  LedAchiversList: "/sellerApi/LedAchiversList",
  checkpincode: "/sellerApi/checkpincode",
  addItemCart: "/sellerApi/addItemCart",
  getcartitme: "/sellerApi/getcartitme",
  getwishListitme: "/sellerApi/getwishListitme",
  addItemWishFromList: "/sellerApi/addItemWishFromList",
  addItemWish: "/sellerApi/addItemWish",
  moveToCart: "/sellerApi/moveToCart",
  afterLoginAddCart: "/sellerApi/afterLoginAddCart",
  afterLoginAddWishList: "/sellerApi/afterLoginAddWishList",
  removeItemCartCount: "/sellerApi/removeItemCartCount",
  addItemCartCount: "/sellerApi/addItemCartCount",
  removeCartItem: "/sellerApi/removeCartItem",
  removeWishItem: "/sellerApi/removeWishItem",
  removeAllCartItem: "/sellerApi/removeAllCartItem",
  removeAllWishItem: "/sellerApi/removeAllWishItem",
  createAddress: "/sellerApi/createAddress",
  createOrder: "/sellerApi/createOrder",
  getUserAddress: "/sellerApi/getUserAddress",
  getuserOrder: "/sellerApi/getuserOrder",
  getuserdownselllist: "/sellerApi/getuserdownselllist",
  getuserdownselllistNew: "/sellerApi/getuserdownselllistNew",
  getuserOrderDetails: "/sellerApi/getuserOrderDetails",

  getuserdeshboardData: "/sellerApi/getuserdeshboardData",
  addlicenceUser: "/sellerApi/addlicenceUser",
  userallteamlistexportex: "/sellerApi/userallteamlistexportex",
  getuserBussnisslastthreeMonth2: "/sellerApi/getuserBussnisslastthreeMonth2",
  LeaderBoard: "/sellerApi/LeaderBoard",
  LeaderBoardbyAdmin: "/sellerApi/LeaderBoardbysell",

  getsubsubcate: "/publicApi/getsubsubcate",
  getsubsubcatehome: "/publicApi/getsubsubcatehome",
  signupSeller: "/publicApi/signupSeller",
  otpVerify: "/publicApi/otpVerify",
  productDetails: "/publicApi/productDetails",
  productDetailsReleted: "/publicApi/productDetailsReleted",

  getsellerProductListPublice: "/publicApi/getsellerProductListPublice",
  gettagsProductListPublice: "/publicApi/gettagsProductListPublice",
  getsellerProductListPublicefilCate:
    "/publicApi/getsellerProductListPublicefilCate",
  getsellerProductListPublicebycategory:
    "/publicApi/getsellerProductListPublicebycategory",
  getsellerprofile: "/publicApi/getsellerprofile",
  whatsappinquiresubmit: "/publicApi/whatsappinquiresubmit",
  getsubsubCategoryList: "/publicApi/getsubsubCategoryList",
  getThirdLavelCategory: "/publicApi/getThirdLavelCategory",
  getsubsubCategoryListfillforsub: "/publicApi/getsubsubCategoryListfillforsub",
  getsubsubCategoryListfill2: "/publicApi/getsubsubCategoryListfill2",
  createSubscription: "/publicApi/createSubscription",
  getPages: "/publicApi/getPagesPu",
  emailenquirysubmit: "/publicApi/emailenquirysubmit",
  pageDetails: "/publicApi/pageDetails",
  searchProductpub: "/publicApi/searchProductpub",
  sendOtpSeller: "/publicApi/sendOtpSeller",
  otpVerifyseller: "/publicApi/otpVerifyseller",
  signinSellereSecurite: "/publicApi/signinSellereSecurite",
  footerPagepageListetPu: "/publicApi/footerPagepageListetPu",
  productclick: "/publicApi/productclick",
  gethomePro: "/publicApi/gethomePro",
  getSellerListPublic: "/publicApi/getSellerListPublic",
  getsellerProductListPublicebymaincategory2:
    "/publicApi/getsellerProductListPublicebymaincategory2",
  getsellerProductListPublicebymaincategory2Subcate:
    "/publicApi/getsellerProductListPublicebymaincategory2Subcate",
  getsellerProductListPublicebymaincategory2newLaunch:
    "/publicApi/getsellerProductListPublicebymaincategory2newLaunch",
  getsellerProductListPublicebymaincategory2BestSelling:
    "/publicApi/getsellerProductListPublicebymaincategory2BestSelling",
  getsellerProductgpgProduct: "/publicApi/getsellerProductgpgProduct",
  getInvoice1: "/publicApi/getInvoice",

  // apiAdmin
  signinSeller: "/publicApi/signinSeller",
  getsellerProductList: "/sellerApi/getsellerProductList",
  createSellerProduct: "/sellerApi/createSellerProduct",
  searchSellerProduct: "/sellerApi/searchSellerProduct",
  deleteSellerProduct: "/sellerApi/deleteSellerProduct",
  createBussnissPro: "/sellerApi/createBussnissPro",
  getBussProfile: "/sellerApi/getBussProfile",
  getBussProfile1: "/sellerApi/getBussProfile1",
  updateWhatsaapNumber: "/sellerApi/updateWhatsaapNumber",
  verifyWhatsapp: "/sellerApi/verifyWhatsapp",
  updateBussLogo: "/sellerApi/updateBussLogo",
  updateBussProfile: "/sellerApi/updateBussProfile",
  getPackageList: "/sellerApi/getPackageList",
  createPurchase: "/sellerApi/createPurchase",
  getsellerTransaction: "/sellerApi/getsellerTransaction",
  getprofile: "/sellerApi/getprofile",
  genelogybyuser: "/sellerApi/genelogybyuser",
  getuserBussnissMonth: "/sellerApi/getuserBussnissMonth",
  userCommissionpreviousmonth: "/sellerApi/userCommissionpreviousmonth",
  updatesellerProduct: "/sellerApi/updatesellerProduct",
  getSellerTicketList: "/sellerApi/getSellerTicketList",
  createSellerTickets: "/sellerApi/createSellerTickets",
  getmessageSupportList: "/sellerApi/getmessageSupportList",
  createMessage: "/sellerApi/createMessage",
  deleteacountByseller: "/sellerApi/deleteacountByseller",
  copyProduct: "/sellerApi/copyProduct",

  getInvoice: "/sellerApi/getInvoice",
  getEmailenquirySeller: "/sellerApi/getEmailenquirySeller",
  getsellerWhatsappinquire: "/sellerApi/getsellerWhatsappinquire",
  searchtags: "/sellerApi/searchtags",
  passwordChange: "/sellerApi/passwordChange",
  topViewnewSeller: "/sellerApi/topViewnewSeller",
  sellerDashboardState: "/sellerApi/sellerDashboardState",
  getExpireDate: "/sellerApi/getExpireDate",
  getsellerprofilebyseller: "/sellerApi/getsellerprofilebyseller",
  sellerDateWiseReport: "/sellerApi/sellerDateWiseReport",
  sellerDirectTeam: "/sellerApi/sellerDirectTeam",
  sellerDirectTeamfilter: "/sellerApi/sellerDirectTeamfilter",
  sellerDirectTeamfilterTeamSale: "/sellerApi/sellerDirectTeamfilterTeamSale",
  checkstocknow: "/sellerApi/checkstocknow",
  userMonthIncome: "/sellerApi/userMonthIncome",
  userstatement: "/sellerApi/userstatement",
  createChelenge: "/sellerApi/createChelenge",
  userallteamlistThisMonth: "/sellerApi/userallteamlistThisMonth",
  userallteamlistThisMonthPurchase:
    "/sellerApi/userallteamlistThisMonthPurchase",
  userallteamlist: "/sellerApi/userallteamlist",
  userallteamlistActive: "/sellerApi/userallteamlistActive",
  userallteamlistfilter: "/sellerApi/userallteamlistfilter",
  weekWiseSale: "/sellerApi/weekWiseSale",
  dayWiseSale: "/sellerApi/dayWiseSale",
  myTeamCount: "/sellerApi/myTeamCount",
  getChelenge: "/sellerApi/getChelenge",
  edituserProfileByuser: "/sellerApi/edituserProfileByuser",
  edituserKycByUser: "/sellerApi/edituserKycByUser",
  edituserProfileimageByUser: "/sellerApi/edituserProfileimageByUser",

  getAdsliderList: "/publicApi/getAdsliderList",
  getsliderList: "/publicApi/getsliderList2",
  getBlogListPub: "/publicApi/getBlogListPub",
  getBlogDetails: "/publicApi/getBlogDetails",
  gethomePop: "/publicApi/gethomePop",
  getlistfaqs: "/publicApi/getlistfaqs",
  getInvoceDetails: "/publicApi/getInvoceDetails",
  createContactqueries: "/publicApi/createContactqueries",
};
